import { generateTypes } from '../utils/HttpReducerHelper';
import { createType } from '../utils/helpers';

// Deprecated: As soon as we adopt new sign in flow
// Auth0 direct flow must be removed
export const LOGIN_REQUEST = createType('AUTH', 'LOGIN_REQUEST');
export const LOGIN_SUCCESS = createType('AUTH', 'LOGIN_SUCCESS');
export const LOGIN_FAILURE = createType('AUTH', 'LOGIN_FAILURE');
export const LOGIN_CALLBACK = createType('AUTH', 'LOGIN_CALLBACK');
export const LOGOUT = createType('AUTH', 'LOGOUT');
export const LOGOUT_SUCCESS = createType('AUTH', 'LOGOUT_SUCCESS');
export const DEMASQUERADE = createType('AUTH', 'DEMASQUERADE');
export const REQUEST_REFRESH = createType('AUTH', 'REQUEST_REFRESH');
export const REQUEST_LOGIN_BY_SESSION = createType('AUTH', 'REQUEST_LOGIN_BY_SESSION');
export const REFRESH_IN_PROGRESS = createType('AUTH', 'REFRESH_IN_PROGRESS');
export const REFRESH_SUCCESS = createType('AUTH', 'REFRESH_SUCCESS');
export const REFRESH_FAILURE = createType('AUTH', 'REFRESH_FAILURE');
// New platform login
export const SIGN_IN = generateTypes('AUTH', 'SIGN_IN');
export const REQUEST_INTEGRATION_AUTHORIZATION_URL = createType(
  'AUTH',
  'REQUEST_INTEGRATION_AUTHORIZATION_URL',
);
export const REMOVE_INTEGRATION_CONNECTED = createType('AUTH', 'REMOVE_INTEGRATION_CONNECTED');
export const REMOVE_TRADE_HISTORY_INTEGRATION_CONNECTED = createType(
  'AUTH',
  'REMOVE_TRADE_HISTORY_INTEGRATION_CONNECTED',
);
export const REDIRECT_TO_AUTH0_LOGIN = createType('AUTH', 'REDIRECT_TO_AUTH0_LOGIN');
export const REQUEST_INTEGRATION_AUTHORIZATION_INVITE_URL = createType(
  'AUTH',
  'REQUEST_INTEGRATION_AUTHORIZATION_INVITE_URL',
);
export const integrationAuthorizationUrl = generateTypes(
  'AUTH',
  'INTEGRATION_AUTHORIZATION_URL_INFO',
);
